/* Welcome coupon strip: show unless dismissed (localStorage), open the signup popup, post the customer form
   via fetch, then reveal the code and copy it. The strip is server-hidden for customers who already ordered. */
(function () {
  var strip = document.querySelector('[data-welcome-strip]');
  var popup = document.querySelector('[data-welcome-popup]');
  if (!strip || !popup) return;
  var key = strip.dataset.key || 'welcome-strip';
  var get = function (k) { try { return localStorage.getItem(k); } catch (e) { return null; } };
  var set = function (k, v) { try { localStorage.setItem(k, v); } catch (e) {} };
  if (get(key + ':dismissed') === '1') strip.hidden = true;
  var opener = null;
  var card = popup.querySelector('.welcome-popup__card');
  var focusables = function () { return Array.prototype.slice.call(card.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])')).filter(function (el) { return el.offsetParent !== null; }); };
  var open = function () {
    opener = document.activeElement;
    popup.hidden = false;
    document.body.classList.add('welcome-popup-open');
    Array.prototype.forEach.call(document.body.children, function (el) { if (!el.contains(popup) && el.tagName !== 'SCRIPT') { el.setAttribute('inert', ''); el.setAttribute('data-welcome-inert', ''); } });
    var first = popup.querySelector('input[type="email"]');
    if (get(key + ':revealed') === '1') reveal();
    if (first && !popup.querySelector('[data-welcome-reveal]:not([hidden])')) first.focus();
  };
  var close = function () {
    popup.hidden = true;
    document.body.classList.remove('welcome-popup-open');
    document.querySelectorAll('[data-welcome-inert]').forEach(function (el) { el.removeAttribute('inert'); el.removeAttribute('data-welcome-inert'); });
    if (opener && typeof opener.focus === 'function') opener.focus();
  };
  /* focus stays inside the dialog */
  popup.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab') return;
    var f = focusables(); if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });
  var reveal = function () {
    var form = popup.querySelector('[data-welcome-form]');
    var box = popup.querySelector('[data-welcome-reveal]');
    if (form) form.hidden = true;
    if (box) box.hidden = false;
    set(key + ':revealed', '1');
    var copyBtn = popup.querySelector('[data-welcome-copy]');
    if (copyBtn && !popup.hidden) copyBtn.focus();
  };
  strip.querySelector('[data-welcome-open]').addEventListener('click', open);
  strip.querySelector('[data-welcome-dismiss]').addEventListener('click', function () { strip.hidden = true; set(key + ':dismissed', '1'); });
  popup.querySelectorAll('[data-welcome-dismiss-popup]').forEach(function (b) { b.addEventListener('click', close); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !popup.hidden) close(); });
  var form = popup.querySelector('[data-welcome-form]');
  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = form.querySelector('[type="submit"]');
      if (btn) btn.disabled = true;
      fetch(form.action, { method: 'POST', body: new FormData(form), credentials: 'same-origin', headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          /* Shopify answers the customer form with the page; a challenge page means the signup must be completed there */
          if (/\/challenge/.test(html) && html.indexOf('g-recaptcha') > -1) { form.submit(); return; }
          reveal();
        })
        .catch(function () { form.submit(); })
        .finally(function () { if (btn) btn.disabled = false; });
    });
  }
  var copy = popup.querySelector('[data-welcome-copy]');
  if (copy) {
    copy.addEventListener('click', function () {
      var code = popup.querySelector('[data-welcome-code]');
      if (!code || !navigator.clipboard) return;
      navigator.clipboard.writeText(code.textContent.trim()).then(function () { copy.textContent = copy.dataset.copied || copy.textContent; });
    });
  }
  if (document.querySelector('[data-welcome-posted]')) { open(); reveal(); }
})();
